import "bootstrap/dist/css/bootstrap.min.css";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useRef, useState } from 'react';
import S3 from "react-aws-s3";
import apis from '../../api';
import Video from '../Video/Video';
import '../../DataTableDemo.css';
import { LabelField } from './Firms.styles';
import uploadFileS3 from '../../services/uploadFileS3';
import { InputNumber } from "primereact/inputnumber";
import SkeletonTable from "../SkeletonTable/SkeletonTable";
import { SelectButton } from 'primereact/selectbutton';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Firms
Description : Tabla para creación y consulta de firmas.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

export default function Firms() {

  /*Propiedades del componente*/
  const [firmId, setFirmId] = useState("");
  const [nombre, setNombre] = useState("");
  const [cargo, setCargo] = useState("");
  const [mesesVariable, setMesesVariable] = useState("")
  const [firma, setFirma] = useState("");
  const [piePagina, setPiePagina] = useState("");
  const [cambio, setCambio] = useState(false);
  const [grupoConceptos, setGrupoConceptos] = useState("");
  const [concepto, setConcepto] = useState("")

  /*Listas de valor del componente*/
  const [listaEmpleados, setListaEmpleados] = useState([]);
  const [listaConceptos, setListaConceptos] = useState([]);

  /*Propiedades de los modales del componente*/
  const [rowId, setRowId] = useState(0);

  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);

  const [isOpenConcept, setIsOpenConcept] = React.useState(false);
  const [isOpenEliminarConcept, setIsOpenEliminarConcept] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [files, setFiles] = useState([])

  /*Constantes globales para el componente*/
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem", justifySelf: "center" }
  const fileUploadRef = useRef(null);
  const toast = useRef(null);

  const [rowDataConcept, setRowDataConcept] = useState([]);
  const [rowsConcept, setRowsConcept] = useState([]);
  const [first2Concept, setFirst2Concept] = useState(0);
  const [rows2Concept, setRows2Concept] = useState(5);
  const [selectedRowsConcept, setSelectedRowsConcept] = useState(null);
  const [filters1Concept, setFilters1Concept] = useState(null);
  const [globalFilterValue1Concept, setGlobalFilterValue1Concept] = useState('');

  const [tipoFirmante, setTipoFirmante] = useState('N')
  const [docFirmante, setDocFirmante] = useState('')

  const options = [
    { name: 'No', value: 'N' },
    { name: 'Si', value: 'S' }
  ]

  useEffect(() => {
    /*Se cargan los datos de las listas de valores y de la tabla del componente*/
    setListas()
    setTabla();
  }, [rowId]);

  /*Funciones y propiedades que manejan la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModal()} />
      </React.Fragment>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Actualizar firma" tooltipOptions={{ position: 'top' }} onClick={() => { setFirmId(rowData["ID"]); initializeData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar firma" tooltipOptions={{ position: 'top' }} onClick={() => { setFirmId(rowData["ID"]); showModalEliminar() }} />
      </div>
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Función que define todos los filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'FIRM': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'FOOT_PAGE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  /*Funciones y propiedades que manejan la tabla del componente*/
  const onCustomPage2Concept = (event) => {
    setFirst2Concept(event.first);
    setRows2Concept(event.rows);
  }

  const template2Concept = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const leftToolbarTemplateConcept = () => {
    return (
      <div className="flex align-items-center justify-content-between">
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModalConcept()} />
        <span style={{ fontWeight: "bold" }}>Conceptos disponibles para el promedio</span>
      </div>
    )
  }

  const actionBodyTemplateConcept = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar firma" tooltipOptions={{ position: 'top' }}
          onClick={() => { setConcepto(rowData["CONCEPT"]); showModalEliminarConcept() }} />
      </div>
    )
  }

  const renderHeader1Concept = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </span>
      </div>
    )
  }

  const onGlobalFilterChange1Concept = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1Concept = () => {
    initFilters1();
  }

  const initFilters1Concept = () => {
    /*Función que define todos los filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'FIRM': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'FOOT_PAGE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1Concept = renderHeader1();

  const matchModesConcept = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  /*Funciones que manejan el comportamiento de los modales del componente*/
  const showModal = () => {
    setIsOpen(true);
    setTablaConceptos()
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = () => {
    setIsOpen_(true);
    setTablaConceptos()
  };

  const hideModal_ = () => {
    setIsOpen_(false)
  };

  const showModalEliminar = () => {
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalConcept = () => {
    setIsOpenConcept(true);
  };

  const hideModalConcept = () => {
    setIsOpenConcept(false);
    limpiarConcepto();
  };

  const showModalEliminarConcept = () => {
    setIsOpenEliminarConcept(true);
  };

  const hideModalEliminarConcept = () => {
    setIsOpenEliminarConcept(false)
  };

  async function limpiar() {
    setNombre("");
    setCargo("");
    setFirma("");
    setDocFirmante("")
    setTipoFirmante("N")
    setMesesVariable("")
    setPiePagina("")
    setFirmId("")

  }

  async function limpiarConcepto() {
    setConcepto("")
  }

  async function setListas() {
    await apis.getValueListFirm(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
      let empleados = res.data["CONTRACTS"];
      let _grupoConcepto = res.data["GROUP_AVG"];
      let _conceptos = res.data["CONCEPTS"]
      let contenidoEmpleados = [];

      empleados.forEach(element => {
        contenidoEmpleados.push({ "code": '' + element.CODE + '', "name": '' + element.NAME + '', 'job': '' + element.JOB + '' })
      })
      setListaEmpleados(contenidoEmpleados)
      setGrupoConceptos(_grupoConcepto)
      setListaConceptos(_conceptos)
    })
  }

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    try {
      await apis.getFirm(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('token'), headers).then(res => {
        console.log(res.data)
        console.log(res.data.length)
        if (res.data["CONTRACTS"].length > 0) {
          let data = res.data["CONTRACTS"]
          let contenidoTabla = []
          data.forEach(element => {
            let nombre = element.NAME ? element.NAME.split("|") : ""
            let cargo = element.JOB ? element.JOB.split("|") : ""
            contenidoTabla.push({
              ...element,
              ID: element.CONFIG_ID, CONTRACT_ID: element.CODE, NUMBER_ID: nombre[0],
              NAME: nombre[1], JOB_ID: cargo[0], JOB_NAME: cargo[1], FIRM: element.SIGNATURE, IMAGE: element.IMAGES,
              FULLNAME: element.NAME, FULLJOB: element.JOB, FOOT_PAGE: element.FOOT_PAGE, AVG_PROM: element.AVG_PROM
            })
          })
          console.log(contenidoTabla)
          setRows(contenidoTabla)
          setRowData(contenidoTabla)
          setLoadPage(true)
        }
        else {
          setRows([])
          setRowData([])
          setLoadPage(true)
        }
      })
    }
    catch (err) {
      setLoadPage(true)
    }
  }

  async function setTablaConceptos() {
    /*Función encargada de cargar la información de la tabla del componente*/
    const _grupoConceptos = grupoConceptos
    await apis.getPayrollGroupConf(localStorage.getItem('entity'), localStorage.getItem('client'), _grupoConceptos, headers).then(res => {
      if (res.data["CONCEPTS"].length > 0) {
        let data = res.data["CONCEPTS"]
        let contenidoTabla = []
        data.forEach(element => {
          contenidoTabla.push({ CONCEPT: element.CODE, NAME: element.NAME, TYPE: element.TYPE })
        })
        setRowsConcept(contenidoTabla)
        setRowDataConcept(contenidoTabla)
      }
      else {
        setRowsConcept([])
        setRowDataConcept([])
      }
    })
  }

  async function postFirms() {
    /*Función encargada de agregar una firma nueva a la base de datos*/

    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _empleado = nombre.code;
    const _mesesVariable = mesesVariable;
    const _piePagina = piePagina;
    const _nombreFirmante = typeof (nombre) === 'string' ? nombre : ""
    const _tipoFirmante = tipoFirmante
    const _cargoFirmante = cargo ? cargo : ""
    const _cedulaFirmante = docFirmante
    let _firma = "";

    if (files.length > 0) {
      try {
        let _archivo = files[0]
        let _cliente = localStorage.getItem("client")
        let url = uploadFileS3(_entity, _cliente, _archivo, "firma", "firma", 'jpg', headers)
        _firma = url
      }
      catch (err) {
        setLoading1(false)
        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      }
    }

    const firm = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CODE: _empleado,
      AVG_PROM: _mesesVariable,
      SIGNATURE: _firma,
      FOOT_PAGE: _piePagina,
      SIGNATORY_TYPE: _tipoFirmante,
      SIGNATORY_NAME: _nombreFirmante,
      SIGNATORY_JOB: _cargoFirmante,
      SIGNATORY_CC: _cedulaFirmante
    }

    try {
      await apis.postFirm(firm, headers).then(res => {
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Firma agregada exitosamente' });
      })
      setTabla()
      limpiar();
      hideModal();
    }
    catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }

  }

  async function putFirms() {
    /*Función encargada de actualizar la información de la firma en la base de datos*/

    const _id = firmId;
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _empleado = nombre.code;
    const _mesesVariable = mesesVariable;
    const _piePagina = piePagina;
    let _firma = firma;
    const _nombreFirmante = typeof (nombre) === 'string' ? nombre : nombre.name
    const _tipoFirmante = tipoFirmante
    const _cargoFirmante = typeof (cargo) === 'string' ? cargo : cargo.code
    const _cedulaFirmante = docFirmante

    if (files.length > 0) {
      try {
        let _archivo = files[0]
        let _cliente = localStorage.getItem("client")
        let url = uploadFileS3(_entity, _cliente, _archivo, "firma", "firma", 'jpg', headers)
        _firma = url
      }
      catch (err) {
        setLoading1(false)
        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      }
    }

    const firm = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CODE: _empleado,
      AVG_PROM: _mesesVariable,
      SIGNATURE: _firma,
      FOOT_PAGE: _piePagina,
      CONFIG_ID: _id,
      SIGNATORY_TYPE: _tipoFirmante,
      SIGNATORY_NAME: _nombreFirmante,
      SIGNATORY_JOB: _cargoFirmante,
      SIGNATORY_CC: _cedulaFirmante
    }

    try {
      await apis.putFirm(firm, headers).then(res => {
        setLoading2(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Firma actualizada exitosamente' });
      })
      setTabla()
      limpiar();
      hideModal_();
    }
    catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function deleteFirms() {
    /*Función encargada de eliminar la firma de la base de datos*/
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _firmId = firmId;

    try {
      await apis.deleteFirm(_entity, _cliente, _firmId, headers).then(res => {
        console.log(res.data)
        setLoading3(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Firma eliminada exitosamente' });
      })

      setTabla();
      limpiar();
      hideModalEliminar();
    } catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
    }
  }

  async function postConcept() {
    /*Función encargada de guardar el concepto de nómina en la base de datos*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _concepto = concepto.CODE
    const _idGroup = grupoConceptos

    const companyPayrollGroup = {
      CLIENT: _cliente,
      ENTITY: _entity,
      IDGROUP: _idGroup,
      CONCEPT: _concepto
    }

    try {
      await apis.postPayrollGroupConf(companyPayrollGroup, headers).then(res => {
        setLoading4(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Concepto agregado exitosamente' });
      })
      setTablaConceptos();
      setListas();
      hideModalConcept();
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function deleteConcept() {

    /*Función encargada de eliminar el concepto de nómina de la base de datos*/
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _concepto = concepto
    const _idGroup = grupoConceptos

    try {
      await apis.deletePayrollGroupConf(_entity, _cliente, _idGroup, _concepto, headers).then(res => {
        setLoading5(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Concepto eliminado exitosamente' });
      })
      setTablaConceptos();
      setListas();
      hideModalEliminarConcept();
    }
    catch (err) {
      setLoading5(false)
      toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
    }
  }

  /*Header y footers de los modales del componente*/
  const addFooter = (
    <div>
      <div>
        <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
        <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postFirms() }} />
      </div>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar firma</h3>
    </div>
  )

  const updateFooter = (
    <div>
      <div>
        <Button onClick={() => { setLoading2(false); hideModal_() }}>Cancelar</Button>
        <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); putFirms() }} />
      </div>
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar firma</h3>
    </div>
  )

  const deleteFooter = (
    <div>
      <Button onClick={() => { setLoading3(false); hideModalEliminar() }}>Cancelar</Button>
      <Button label='Si' loading={loading3} onClick={() => { setLoading3(true); deleteFirms() }} />
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar la firma?</h3>
    </div>
  )

  const addFooterConcept = (
    <div>
      <Button onClick={() => { setLoading4(false); hideModalConcept() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading4} onClick={() => { setLoading4(true); postConcept() }} />
    </div>
  );

  const addHeaderConcept = (
    <div>
      <h3>Agregar concepto</h3>
    </div>
  )

  const deleteFooterConcept = (
    <div>
      <Button onClick={() => { setLoading5(false); hideModalEliminarConcept() }}>Cancelar</Button>
      <Button label='Si' loading={loading5} onClick={() => { setLoading5(true); deleteConcept() }} />
    </div>
  );

  const deleteHeaderConcept = (
    <div>
      <h3>¿Desea eliminar el concepto?</h3>
    </div>
  )

  function initializeData(rowData) {
    /*Función encargada de inicializar las propiedades del componente con los valores de la firma seleccionada*/
    setFirmId(rowData.ID);
    setNombre({ code: rowData.CONTRACT_ID, id: rowData.NUMBER_ID, name: rowData.NAME });
    setCargo({ code: rowData.JOB_ID, name: rowData.JOB_NAME });
    setMesesVariable(rowData.AVG_PROM)
    setFirma(rowData.SIGNATURE)
    setPiePagina(rowData.FOOT_PAGE)
    setTipoFirmante(rowData.SIGNATORY_TYPE)
    setDocFirmante(rowData.SIGNATORY_CC)
    showModal_();
  }

  const imageBodyTemplate = (rowData) => {
    return <img src={rowData.IMAGE}
      alt="Firma"
      style={{
        width: "130px",
        height: "80px",
        boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)"
      }}
    />;
  }


  /*Renderizado del componente*/
  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">

        <Toast ref={toast} />
        <Dialog header={addHeader} visible={isOpen}
          position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">¿Es firmante externo?</LabelField>
          <SelectButton options={options} value={tipoFirmante} optionLabel="name" onChange={(e) => setTipoFirmante(e.value)} />
          <LabelField htmlFor="label">Nombre</LabelField>
          {tipoFirmante === 'N' ?
            <Dropdown style={elementWidth} value={nombre} autoFocus
              filter showClear filterBy="name" emptyMessage={"No hay empleados disponibles"}
              options={listaEmpleados} placeholder={"Seleccione el empleado"}
              onChange={(e) => {
                console.log(e.value)
                let c = e.value !== undefined ? e.value.job.split("|") : ["", ""]
                setNombre(e.value)
                setCargo({ code: c[0], name: c[1] })
              }}
              optionLabel='name'
            />
            :
            <InputText
              style={elementWidth}
              id="label2"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          }
          <LabelField htmlFor="label">Cargo</LabelField>
          <InputText
            style={elementWidth}
            id="label2"
            type="text"
            value={cargo.name}
            disabled={tipoFirmante === 'N'}
            onChange={(e) => setCargo(e.target.value)}
          />
          {
            tipoFirmante === 'S' &&
            <>
              <LabelField htmlFor="label">Cédula</LabelField>
              <InputText
                style={elementWidth}
                id="label2"
                type="number"
                value={docFirmante}
                onChange={(e) => setDocFirmante(e.target.value)}
              />
            </>
          }
          <LabelField htmlFor="label">Número de meses para promediar variable</LabelField>
          <InputNumber
            style={elementWidth}
            value={mesesVariable}
            min={1}
            onValueChange={(e) => setMesesVariable(e.value)}
          />
          <LabelField htmlFor="label">Firma</LabelField>
          <FileUpload mode="basic" name="demo[]" ref={fileUploadRef} accept="image/*" maxFileSize={2000000} chooseLabel="Seleccionar"
            onValidationFail={() => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
            }} onClear={() => setFiles([])}
            onSelect={(e) => setFiles(e.files)}
          />
          <LabelField htmlFor="label">Pie de página</LabelField>
          <InputText
            style={elementWidth}
            id="label2"
            type="text"
            value={piePagina}
            onChange={(e) => setPiePagina(e.target.value)}
          />
          <div className="flex justify-content-end mt-2">
            <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postFirms() }} />
          </div>
          <div className="card mt-2">
            <Toolbar left={leftToolbarTemplateConcept}></Toolbar>
            <DataTable className="text-xs" value={rowsConcept} first={first2Concept} rows={rows2Concept} onPage={onCustomPage2Concept}
              responsiveLayout="scroll" selection={selectedRowsConcept} paginator paginatorTemplate={template2}
              onSelectionChange={(e) => setSelectedRowsConcept(e.value)} dataKey="CONCEPT"
              size="small" globalFilterFields={['CONCEPT', 'NAME', 'TYPE']} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONCEPT" header="Concepto" showFilterOperator={false} sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} sortable></Column>
              <Column field="TYPE" header="Tipo" showFilterOperator={false} sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplateConcept} />
            </DataTable>
          </div>
        </Dialog>
        <Dialog header={updateHeader} visible={isOpen_}
          position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">¿Es firmante externo?</LabelField>
          <SelectButton options={options} value={tipoFirmante} optionLabel="name" onChange={(e) => setTipoFirmante(e.value)} />
          <LabelField htmlFor="label">Nombre</LabelField>
          {tipoFirmante === 'N' ?
            <Dropdown style={elementWidth} value={nombre} autoFocus
              filter showClear filterBy="name" emptyMessage={"No hay empleados disponibles"}
              options={listaEmpleados} placeholder={nombre ? nombre.id + '-' + nombre.name : ""}
              onChange={(e) => {
                console.log(e.value)
                let c = e.value !== undefined ? e.value.job.split("|") : ["", ""]
                setNombre(e.value)
                setCargo({ code: c[0], name: c[1] })
              }}
              optionLabel='name'
            />
            :
            <InputText
              style={elementWidth}
              id="label2"
              type="text"
              value={nombre.name}
              onChange={(e) => setNombre(e.target.value)}
            />
          }
          <LabelField htmlFor="label">Cargo</LabelField>
          <InputText
            style={elementWidth}
            id="label2"
            type="text"
            value={cargo.name}
            disabled={tipoFirmante === 'N'}
            onChange={(e) => setCargo(e.target.value)}
          />
          {
            tipoFirmante === 'S' &&
            <>
              <LabelField htmlFor="label">Cédula</LabelField>
              <InputText
                style={elementWidth}
                id="label2"
                type="number"
                value={docFirmante}
                onChange={(e) => setDocFirmante(e.target.value)}
              />
            </>
          }
          <LabelField htmlFor="label">Número de meses para promediar variable</LabelField>
          <InputNumber
            style={elementWidth}
            value={mesesVariable}
            min={1}
            onValueChange={(e) => setMesesVariable(e.value)}
          />
          <LabelField htmlFor="label">Firma</LabelField>
          <FileUpload mode="basic" name="demo[]" ref={fileUploadRef} accept="image/*" maxFileSize={2000000} chooseLabel="Seleccionar"
            onValidationFail={() => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
            }} onClear={() => setFiles([])}
            onSelect={(e) => setFiles(e.files)}
          />
          <LabelField htmlFor="label">Pie de página</LabelField>
          <InputText
            style={elementWidth}
            id="label2"
            type="text"
            value={piePagina}
            onChange={(e) => setPiePagina(e.target.value)}
          />
          <div className="flex justify-content-end mt-2">
            <Button onClick={() => { setLoading2(false); hideModal_() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); putFirms() }} />
          </div>
          <div className="card mt-1">
            <Toolbar start={leftToolbarTemplateConcept}></Toolbar>
            <DataTable className="text-xs" value={rowsConcept} first={first2Concept} rows={rows2Concept} onPage={onCustomPage2Concept}
              selection={selectedRowsConcept} paginator paginatorTemplate={template2}
              onSelectionChange={(e) => setSelectedRowsConcept(e.value)} dataKey="CONCEPT"
              size="small" globalFilterFields={['CONCEPT', 'NAME', 'TYPE']} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONCEPT" header="Concepto" showFilterOperator={false} sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} sortable></Column>
              <Column field="TYPE" header="Tipo" showFilterOperator={false} sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplateConcept} />
            </DataTable>
          </div>
        </Dialog>
        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>
        <Dialog header={addHeaderConcept} footer={addFooterConcept} visible={isOpenConcept}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConcept}>
          <LabelField htmlFor="label">Concepto</LabelField>
          <Dropdown style={elementWidth} value={concepto} autoFocus
            filter showClear filterBy="NAME" emptyMessage={"No hay conceptos disponibles"}
            options={listaConceptos} placeholder={"Seleccione el concepto"}
            onChange={(e) => {
              //console.log(e.value)
              setConcepto(e.value)
            }}
            optionLabel='NAME'
          />
        </Dialog>
        <Dialog header={deleteHeaderConcept} footer={deleteFooterConcept} visible={isOpenEliminarConcept}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminarConcept}>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Firma</span>
          <Video header="Instructivo proceso de firmas" url={localStorage.getItem('FIRMS_VIDEO')} />
        </div>
        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} />
            <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NAME', 'JOB_NAME', 'FIRM', 'FOOT_PAGE']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="JOB_NAME" header="Cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
              <Column field="AVG_PROM" header="Meses para promediar variable" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por meses" sortable></Column>
              <Column field="IMAGE" header="Firma" body={imageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por firma" sortable></Column>
              <Column field="FOOT_PAGE" header="Pie de página" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por pie de página" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>

  );
}